import React from 'react';
import { clickableClassName, dblSecondClickTimeoutDuration } from '../components/shared/InteractiveSvg';

/**
 * skipFirstClickTapOnDbl:
 * means if will happened dbl click, will be raised only callback onDblClickTap and skipped onFastClickTap
 * if this prop will be 'false' - both (onFastClickTap and onDblClickTap) will be raised on dbl click
 *
 * provide events:
 * - onFastClickTap
 * - onDblClickTap
 **/
export default function svgElementClickableListener(Component) {

    return class extends React.Component {

        constructor(props) {
            super(props);

            this.onEmergencyStopHandler = this.onEmergencyStopHandler.bind(this);
            this.onFastClickTapHandler = this.onFastClickTapHandler.bind(this);
            this.onDblClickTapHandler = this.onDblClickTapHandler.bind(this);

            this.svgElNode = null;
            this.waitingDblClickTapTimeout = null;
        }

        setSvgElRef(svgElNode) {
            if (!this.svgElNode && svgElNode) {
                this.svgElNode = svgElNode;
                this.addSubscriptions();
            }
        }

        addSubscriptions() {
            this.svgElNode.addEventListener('onActionStart', this.onEmergencyStopHandler);
            this.svgElNode.addEventListener('onEmergencyStop', this.onEmergencyStopHandler);
            this.svgElNode.addEventListener('onFastClickTap', this.onFastClickTapHandler);
            this.svgElNode.addEventListener('onDblClickTap', this.onDblClickTapHandler);
        }

        onEmergencyStopHandler(ev) {
            clearTimeout(this.waitingDblClickTapTimeout);
        }

        onFastClickTapHandler(event) {
            const {clickable, onFastClickTap} = this.props;
            if (clickable) {
                this.checkDblClickTapOnFirst(() => {
                    if (onFastClickTap) {
                        onFastClickTap(event.detail);
                    }
                });
            }
        }

        onDblClickTapHandler(ev) {
            const {clickable, onDblClickTap} = this.props;
            if (clickable && onDblClickTap) {
                onDblClickTap(ev.detail);
            }
        }

        checkDblClickTapOnFirst(firstClickTapClb) {
            const { skipFirstClickTapOnDbl } = this.props;
            if (skipFirstClickTapOnDbl) {
                this.waitingDblClickTapTimeout = setTimeout(() => {
                    firstClickTapClb();
                }, dblSecondClickTimeoutDuration + 50);
            } else {
                firstClickTapClb();
            }
        }

        removeSubscriptions() {
            this.svgElNode.removeEventListener('onActionStart', this.onEmergencyStopHandler);
            this.svgElNode.removeEventListener('onEmergencyStop', this.onEmergencyStopHandler);
            this.svgElNode.removeEventListener('onFastClickTap', this.onFastClickTapHandler);
            this.svgElNode.removeEventListener('onDblClickTap', this.onDblClickTapHandler);
        }

        componentWillUnmount() {
            if (this.svgElNode) {
                this.removeSubscriptions();
            }
        }

        render() {
            const { clickable, skipFirstClickTapOnDbl, onFastClickTap, onDblClickTap, ...otherProps } = this.props;

            return <Component {...otherProps} svgElementClickableRef={clickable ? (elem => this.setSvgElRef(elem)) : () => {}} />;
        }
    };
}
